import { create } from 'zustand';
import { subscribeWithSelector } from 'zustand/middleware';

import type { SystemContainerState } from '../types/storeType';

export const useSystemContainerStore = create<SystemContainerState>()(
  subscribeWithSelector(
    (set) => ({
      isLoading: false,

      setLoading: (loading: boolean) => {
        set({ isLoading: loading });
      },
    })
  )
);

